import { render, staticRenderFns } from "./LinksNavigationModal.vue?vue&type=template&id=741405c5"
import script from "./LinksNavigationModal.vue?vue&type=script&lang=js"
export * from "./LinksNavigationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports